<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">Note</span>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-textarea
						outlined
						class="mt-6"
						:value="pratica.notes"
						@input="pratica.notes = $event !== '' ? $event : null"
						label="Note Pratica"
						hide-details
					></v-textarea>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-textarea
						outlined
						class="mt-1"
						:value="accordo.notes"
						@input="accordo.notes = $event !== '' ? $event : null"
						label="Note Accordo"
						hide-details
					></v-textarea>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-textarea
						outlined
						class="mt-1"
						:value="contrattoDiServizio.notes"
						@input="contrattoDiServizio.notes = $event !== '' ? $event : null"
						label="Note Contratto di Servizio"
						hide-details
						:disabled="pratica.contratto_di_servizio_id == null"
					></v-textarea>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="close()"
				:disabled="isSaving"
				class="black--text"
			>
				{{ ciSonoModificheNelleNote ? 'Annulla' : 'Chiudi' }}
			</v-btn>
			<v-btn
				color="secondary"
				@click="updateAll()"
				:disabled="!ciSonoModificheNelleNote"
				:loading="isSaving"
			>
				Salva
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: {
		value: {
			default: null
		},
	}, // pratica object
	
	data() {
		return {
			// backupPratica: null,
			backupPraticaNotes: null,
			backupAccordoNotes: null,
			backupContrattoDiServizioNotes: null,
			pratica: null,
			accordo: null,
			contrattoDiServizio: {
				id: null,
				notes: null
			},
			isSavingPraticaNotes: false,
			isSavingAccordoNotes: false,
			isSavingContrattoDiServizioNotes: false,
		}
	},
	
	created() {
		this.backupPraticaNotes = this.value.notes;
		this.backupAccordoNotes =this.value.accordo.notes;
		this.backupContrattoDiServizioNotes = this.value.contratto_di_servizio?.notes;
		this.pratica = Object.assign({}, this.value);
		this.accordo = Object.assign({}, this.value.accordo);
		this.contrattoDiServizio = Object.assign({}, this.value.contratto_di_servizio);
	},
	
	computed: {
		ciSonoModificheNelleNote() {
			return this.pratica.notes !== this.backupPraticaNotes
				|| this.accordo.notes !== this.backupAccordoNotes
				|| this.contrattoDiServizio.notes !== this.backupContrattoDiServizioNotes;
		},
		isSaving() {
			return this.isSavingPraticaNotes
				|| this.isSavingAccordoNotes
				|| this.isSavingContrattoDiServizioNotes;
		}
	},
	
	methods: {
		updateAll() {
			this.updatePraticaNotes();
			this.updateAccordoNotes();
			if (this.pratica.contratto_di_servizio_id != null) this.updateContrattoDiServizioNotes();
			
			this.$watch('isSaving', (newVal) => {
				if (newVal === false) {
					this.close();
				}
			});
		},
		updatePraticaNotes() {
			this.isSavingPraticaNotes = true;
			let pratica = {
				id: this.pratica.id,
				notes: this.pratica.notes
			}
			let formData = new FormData();
			formData.append('pratica', JSON.stringify(pratica));
			axios.patch(`/api/pratiche/${pratica.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.$emit('pratica-notes-updated', {
						praticaNotesUpdated: this.pratica.notes,
						praticaId: this.pratica.id
					})
				})
				.finally(() => {
					this.isSavingPraticaNotes = false;
				})
		},
		updateAccordoNotes() {
			this.isSavingAccordoNotes = true;
			let accordo = {
				id: this.accordo.id,
				notes: this.accordo.notes
			}
			let formData = new FormData();
			formData.append('accordo', JSON.stringify(accordo));
			axios.patch(`/api/accordi/${accordo.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.$emit('accordo-notes-updated', {
						accordoUpdated: response.data
					})
				})
				.finally(() => {
					this.isSavingAccordoNotes = false;
				})
		},
		updateContrattoDiServizioNotes() {
			this.isSavingContrattoDiServizioNotes = true;
			let contratto_di_servizio = {
				id: this.contrattoDiServizio.id,
				notes: this.contrattoDiServizio.notes
			}
			let formData = new FormData();
			formData.append('contratto_di_servizio', JSON.stringify(contratto_di_servizio));
			axios.patch(`/api/contratti-di-servizio/${contratto_di_servizio.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.$emit('contratto-di-servizio-notes-updated', {
						contrattoDiServizioUpdated: response.data
					})
				})
				.finally(() => {
					this.isSavingContrattoDiServizioNotes = false;
				})
		},
		close() {
			this.$emit('close');
		}
	}
}
</script>